import React from "react";
import { useForm } from "@formspree/react";
import { siteInfo } from "../data/siteInfo";
import FormField from "../components/FormField";
import FormError from "../components/FormError";
import InquirySuccess from "../components/InquirySuccess";
import Icon from "../components/Icon";
import "../css/Contact.css";

export default function Contact() {
  const [state, handleSubmit] = useForm(siteInfo.formId);
  return (
    <div>
      <div className="section-heading">
        <p className="eyebrow">WE’D LOVE TO SEE YOU</p>
        <h2>Your next happy day starts here.</h2>
        <p>
          Stop by for a play day, start planning a birthday, or ask us a
          question. We’re here to help.
        </p>
      </div>
      <div className="contact-grid">
        <div className="visit-contact-card">
          <h3>Visit our little kingdom.</h3>
          <address>
            <Icon name="pin" />
            <span>{siteInfo.address}</span>
          </address>
          <div className="contact-hours">
            <Icon name="clock" />
            <div>
              <strong>Monday–Sunday · {siteInfo.hours}</strong>
              <p>
                Private events can change open play hours. Please call before
                visiting.
              </p>
            </div>
          </div>
          <div className="button-row">
            <a
              className="button button-teal"
              href={siteInfo.directions}
              target="_blank"
              rel="noopener noreferrer"
            >
              Get directions <Icon name="external" />
            </a>
            <a className="button button-secondary" href={siteInfo.phoneHref}>
              <Icon name="phone" /> {siteInfo.phone}
            </a>
          </div>
          <a
            className="contact-email email-link"
            href={`mailto:${siteInfo.email}`}
          >
            {siteInfo.email}
          </a>
          <div className="venue-map">
            <iframe
              src="https://www.google.com/maps/embed/v1/place?key=AIzaSyA15VLVFgnvnBij74SjAlW0WV2nKHLrXsE&q=19444+Business+Ctr+Dr,+Northridge,+CA+91324"
              title="Kiddie Kingdom location in Northridge"
              width="600"
              height="320"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
          <div className="social-links">
            <a
              href={siteInfo.instagram}
              target="_blank"
              rel="noopener noreferrer"
            >
              Follow on Instagram <Icon name="external" />
            </a>
            <a
              href={siteInfo.facebook}
              target="_blank"
              rel="noopener noreferrer"
            >
              Find us on Facebook <Icon name="external" />
            </a>
          </div>
        </div>
        <div className="contact-form-card">
          {state.succeeded ? (
            <InquirySuccess />
          ) : (
            <>
              <h3>Let’s talk.</h3>
              <p className="form-intro">
                Tell us what you have in mind. All fields are required.
              </p>
              <form
                onSubmit={handleSubmit}
                aria-label="Contact Kiddie Kingdom"
                aria-busy={state.submitting}
              >
                <input
                  type="hidden"
                  name="inquiryType"
                  value="Website contact"
                />
                <FormError errors={state.errors} />
                <fieldset disabled={state.submitting}>
                  <legend className="sr-only">
                    Your contact details and message
                  </legend>
                  <div className="form-grid">
                    <FormField
                      id="contact-first-name"
                      name="first-name"
                      label="First name"
                      autoComplete="given-name"
                      errors={state.errors}
                    />
                    <FormField
                      id="contact-last-name"
                      name="last-name"
                      label="Last name"
                      autoComplete="family-name"
                      errors={state.errors}
                    />
                    <FormField
                      id="contact-email"
                      name="email"
                      label="Email address"
                      type="email"
                      autoComplete="email"
                      errors={state.errors}
                      className="form-field-wide"
                    />
                    <FormField
                      id="contact-subject"
                      name="subject"
                      label="Subject"
                      errors={state.errors}
                      className="form-field-wide"
                    />
                    <FormField
                      id="contact-message"
                      name="message"
                      label="Your message"
                      as="textarea"
                      errors={state.errors}
                      className="form-field-wide"
                    />
                  </div>
                </fieldset>
                <button
                  className="button button-primary"
                  type="submit"
                  disabled={state.submitting}
                >
                  {state.submitting ? "Sending message…" : "Send message"}
                  <Icon />
                </button>
                <p className="form-help">
                  We’ll use your details to respond to your inquiry.
                </p>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
